import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { H3 } from '../../atoms';

import { Button } from '../Button';

const StyledButton = styled(Button)`
  margin-top: 24px;
`;

const StyledCenteredLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-wrap: nowrap;
  background: var(--generic-error-bg);
  width: 100%;
  height: 100%;

  margin: 64px auto;
`;

const GenericError = () => {
  const navigate = useNavigate();
  return (
    <StyledCenteredLayout>
      <H3>Oops, something went wrong</H3>
      <StyledButton
        primary
        onClick={() => {
          navigate(0);
        }}
      >
        Try again
      </StyledButton>
    </StyledCenteredLayout>
  );
};

export { GenericError };
